const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return null
  }
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

const formatLargeNumber = (value) => {
  const number = toFiniteNumber(value)
  if (number === null) {
    return "—"
  }
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: Number.isInteger(number) ? 0 : 2,
  }).format(number)
}

const formatCompactNumber = (value) => {
  const number = toFiniteNumber(value)
  if (number === null) {
    return "—"
  }
  if (Math.abs(number) < 10000) {
    return formatLargeNumber(number)
  }
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(number)
}

const formatUsd = (value) => {
  const number = toFiniteNumber(value)
  if (number === null) {
    return "—"
  }
  const absolute = Math.abs(number)
  if (absolute > 0 && absolute < 0.0001) {
    return number < 0 ? ">-$0.0001" : "<$0.0001"
  }
  const fractionDigits = absolute > 0 && absolute < 0.01 ? 4 : 2
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(number)
}

const formatCoveragePercent = (value) => {
  const number = toFiniteNumber(value)
  if (number === null) {
    return "—"
  }
  return `${number.toFixed(number % 1 === 0 ? 0 : 1)}%`
}

export {
  formatCompactNumber,
  formatCoveragePercent,
  formatLargeNumber,
  formatUsd,
  toFiniteNumber,
}
